var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowGrayDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.931615 2.93101C1.04733 2.81529 1.22694 2.80244 1.35685 2.89243L1.40302 2.93101L4.83398 6.36204L8.26495 2.93101C8.38066 2.81529 8.56028 2.80244 8.69019 2.89244L8.73635 2.93101C8.85206 3.04672 8.86492 3.22633 8.77492 3.35624L8.73635 3.40241L5.06969 7.06908C4.95398 7.18479 4.77436 7.19764 4.64445 7.10765L4.59828 7.06908L0.931615 3.40241C0.801441 3.27223 0.801441 3.06118 0.931615 2.93101Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrayDown);
export default __webpack_public_path__ + "static/media/arrow-gray-down.54584f70.svg";
export { ForwardRef as ReactComponent };